// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"search-filter-options_checkboxWrapper__3CLid"};